import {
  Directive,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subject, Subscription, debounceTime, distinctUntilChanged } from 'rxjs';
import { LIST_QUERY_DEBOUNCE_TIME } from '../config.debounde';

@Directive({
  selector: '[appDebouncedSearch]',
})
export class DebouncedSearchDirective implements OnInit, OnDestroy {
  @Input() minLength = 0;
  @Output() searchChange = new EventEmitter<string>();

  private searchSubject = new Subject<string>();
  private subscription!: Subscription;

  constructor(@Inject(LIST_QUERY_DEBOUNCE_TIME) private debounceTime: number) { }

  ngOnInit(): void {
    this.subscription = this.searchSubject
      .pipe(debounceTime(this.debounceTime), distinctUntilChanged())
      .subscribe((value) => {
        if (value.length >= this.minLength || value.length === 0) {
          this.searchChange.emit(value);
        }
      });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchSubject.next(input.value);
  }
}
